module.exports = __webpack_public_path__ + "img/tusd.2ff5d895.svg";